import React from 'react';
import API from '../../utils/API';
import 'react-datetime/css/react-datetime.css';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import cityTimezones from 'city-timezones';
import moment from 'moment-timezone';
import ExpandableListItem from '../../components/list/expandableListItem';

import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import LocationLookup from '../../components/inputs/locationLookup';
import ColorField from '../../components/inputs/colorField';
import Dropzone from 'react-dropzone';
import ToggleField from '../../components/inputs/toggleField';
import ViewsTable from '../../components/tables/ViewsTable';
import { UncontrolledTooltip } from "reactstrap";

let dropzoneBannerRef;
let dropzoneLogoRef;
const defaultPermissions = {
	details: { label: "Details", slug: 'details', write: true, read: true },
	attendees: { label: "Attendees", slug: 'attendees', write: true, read: true },
	schedule: { label: "Schedule", slug: 'schedule', write: true, read: true },
	groups: { label: "Groups", slug: 'groups', write: true, read: true },
	inventory: { label: "Inventory", slug: 'inventory', write: true, read: true, addon: 'inventory' },
	emails: { label: "Emails", slug: 'emails', write: true, read: true },
	texting: { label: "Texting", slug: 'texting', write: true, read: true, addon: 'texting' },
	forms: { label: "Forms", slug: 'forms', write: true, read: true },
	pages: { label: "Pages", slug: 'pages', write: true, read: true },
	engagement: { label: "Engagement", slug: 'engagement', write: true, read: true, addon: 'engagement' },
	media: { label: "Media", slug: 'media', write: true, read: true },
	insights: { label: "Insights", slug: 'insights', write: true, read: true },
}
class AddEventFromProgramModal extends React.Component {
	constructor(props) {
		super(props);

		const eventBranding = {
			accentColor: props.organization.branding.accentColor,
			fontColor: props.organization.branding.fontColor,
			backgroundColor: props.organization.branding.backgroundColor,
			logo: { name: "Organization Logo", preview: props.organization.branding.logo },
		};
		const metadata = [];

		this.props.customFields.forEach(cf => {
			cf.fields.forEach(field => {
				metadata.push({
					categoryId: cf._id,
					fieldId: field._id,
					fieldLabel: field.fieldName,
					required: field.required,
					type: field.fieldType,
					fieldValue: ''
				})
			});
		});



		const salesforceIntegration = props.organization.integrations.find((integration) => integration.identifier == 'salesforce');
		let sfRegStatus = 'Registered';
		let sfCheckinStatus = 'Checked In';
		let sfNotAttendingStatus = 'Did Not Attend';
		if (salesforceIntegration) {

			salesforceIntegration.requiredFields.forEach((field) => {
				if (field.id === 'registeredStatus') sfRegStatus = field.value;
				if (field.id === 'checkedinStatus') sfCheckinStatus = field.value;
				if (field.id === 'didNotAttendStatus') sfNotAttendingStatus = field.value;
			});
		}
		this.state = {
			sectionCount: metadata.length > 0 ? 3 : 2,
			currentSection: 0,
			nextSectionEnabled: false,
			createEnabled: false,
			chosenProgram: null,
			name: '',
			event: {
				experienceType: '',
				name: '',
				startDate: moment().format('MM/DD/YYYY'),
				endDate: moment().format('MM/DD/YYYY'),
				timezone: '',
				metadata: metadata,
				expectedNumberOfAttendees: 0,
			},
			eventBranding: eventBranding,
			startDate: '',
			endDate: '',
			cityLookup: '',
			timezone: '',
			selectedVenue: {},
			submitting: false,
			invalid: false,
			locations: props.locations,
			currentStep: 0,
			requiredFields: {
				name: false,
				startDate: false,
				endDate: false,
				timezone: false,
				expectedNumberOfAttendees: false,
			},
			customRequiredFields: {},
			requiredCustomFields: [],
			salesforceEnabled: salesforceIntegration ? true : false,
			salesforceToggled: false,
			salesforceCampaign: '',
			salesforceRegistrationStatus: sfRegStatus,
			salesforceCheckedinStatus: sfCheckinStatus,
			salesforceNotAttendingStatus: sfNotAttendingStatus,
			checkedEvent: {},
			searchTerm: '',
			eventTeam: [],
			isConflictsEventName: false,
			submitError: '',
		};
	}

	onDrop = (files) => {
		this.setState({
			eventBranding: {
				...this.state.eventBranding,
				header: files[0]
			}
		});
	};


	onDropLogo = (files) => {
		this.setState({
			eventBranding: {
				...this.state.eventBranding,
				logo: files[0]
			}
		});
	};

	checkRequiredCustomFields = (updateSectionCheck) => {
		console.log("updateSectionCheck:", updateSectionCheck);
		
		const { chosenProgram, event, customRequiredFields, currentSection } = this.state;
		const { metadata } = event;

		let valid = true;
		const requiredFields = this.state.requiredFields;

		chosenProgram.eventDefaults.details.requiredCustomFields.forEach((key) => {
			const programField = metadata.find(cf => cf.fieldId == key);
			if (programField && programField.fieldValue !== '') {
				customRequiredFields[key] = false;
			} else {
				customRequiredFields[key] = true;
				valid = false;
			}
		});
		updateSectionCheck ?
			this.setState({ requiredFields: requiredFields, customRequiredFields, currentSection: valid ? currentSection + 1 : currentSection }) :
			this.setState({ requiredFields: requiredFields, customRequiredFields, createEnabled: valid });
	}


	createEvent = async () => {
		const { handleSubmit } = this.props;
		const { chosenProgram, requiredCustomFields, event, selectedVenue, salesforceToggled, salesforceCampaign } = this.state;
		const { name, timezone, startDate, endDate, allowPublicRegistrations, metadata, experienceType } = event;
		this.setState({ submitting: true, submitError: '' });

		const requiredFields = this.state.requiredFields;
		const editedEvent = {
			name,
			startDate,
			endDate,
			timezone,
			allowPublicRegistrations,
			venue: selectedVenue.new ? selectedVenue.new : selectedVenue.value,
			customFields: requiredCustomFields,
			metadata,
			experienceType,
			expectedNumberOfAttendees: event.expectedNumberOfAttendees,
		};
		let valid = true;

		Object.keys(requiredFields).forEach((key) => {
			if (!editedEvent[key] || editedEvent[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});

		chosenProgram.eventDefaults.details.requiredCustomFields.forEach((key) => {
			const programField = editedEvent.metadata.find(cf => cf.fieldId == key);
			if (programField && programField.fieldValue !== '') {
				requiredFields[key] = false;
				valid = true;
			} else {
				requiredFields[key] = true;
				valid = false;
			}
		});



		if (valid) {
			try {
				const res = await (this.state.isNewVenue
					? handleSubmit({
						eventId: chosenProgram._id,
						members: this.state.eventTeam,
						expectedNumberOfAttendees: editedEvent.expectedNumberOfAttendees,
						programId: chosenProgram._id, name, startDate, endDate,timezone,
						customFields: requiredCustomFields, metadata,
						experienceType,
						integrations: salesforceToggled ? {
							salesforce: {
								campaignName: salesforceCampaign,
								registrationStatus: this.state.salesforceRegistrationStatus,
								checkinStatus: this.state.salesforceCheckedinStatus,
								notAttendedStatus: this.state.salesforceNotAttendingStatus,
							}
						} : {}
					}, selectedVenue, true)
					: handleSubmit({
						programId: chosenProgram._id,
						name,
						startDate,
						endDate,
						timezone,
						allowPublicRegistrations,
						expectedNumberOfAttendees: editedEvent.expectedNumberOfAttendees,
						venue: selectedVenue.value,
						customFields: requiredCustomFields,
						metadata,
						experienceType,
						members: this.state.eventTeam,
						integrations: salesforceToggled ? {
							salesforce: {
								campaignName: salesforceCampaign,
								registrationStatus: this.state.salesforceRegistrationStatus,
								checkinStatus: this.state.salesforceCheckedinStatus,
								notAttendedStatus: this.state.salesforceNotAttendingStatus,
							}
						} : {}

					}, false, true));
				
				if (res === false) {
					this.setState({ submitting: false });
				}
			} catch (e) {
				const message =  e.response.data || 'Request failed.';
				this.setState({ submitting: false, submitError: message });
			}
		} else {
			this.setState({ invalid: true, submitting: false, requiredFields: requiredFields });
		}
	};

	handleMetadataChange = (fieldId, value) => {
		const event = this.state.event;
		event.metadata = event.metadata.map(f => {
			if (f.fieldId == fieldId) {
				f.fieldValue = value;
			}
			return f;
		});
		this.setState({
			event
		}, () => {
			this.checkRequiredCustomFields();
		});
	};

	/* Search */
	searchEntries = (searchText) => {
		this.setState({
			searching: searchText != '' ? true : false,
			searchText: searchText ? searchText : '',
		});
	};

	validateEventName = async (value) => {
		if (!value || value.trim() === '') {
			this.setState({ isConflictsEventName: false });
			return;
		}

		const valueWithoutSpaces = value.replace(/\s+/g, '');
		try {
			const orgId = this.props.organization._id;

			const response = await API().post(`Organizations/${orgId}/reservePath`, {
				name: valueWithoutSpaces.toLowerCase()
			});

			// Check the response value - true means conflict, false means available
			this.setState({
				isConflictsEventName: response.data === true,
			});
		} catch (error) {
			console.error("Error validating path:", error);
			this.setState({
				isConflictsEventName: true,
			});
		}
	}

	renderSection = (section) => {
		const { programs } = this.props;
		const { currentSection, event, eventBranding,
			cityLookup,
			requiredFields,
			chosenProgram,
			salesforceEnabled,
			searchTerm,
			currentMember,
			customRequiredFields,
		} = this.state;
		const cityTimezoneOptions =
			cityLookup != ''
				? cityTimezones.findFromCityStateProvince(cityLookup).map((tz) => {
					return { label: `${tz.city}, ${tz.province}`, value: tz.timezone };
				})
				: [];
		const { experienceType,
			name,
			timezone,
			startDate,
			endDate,
			metadata } = event;

		const columns = {
			name: 'Name',
			experienceType: 'Experience Type',
			eventType: 'event Type',
		};
		const columnTypes = {
			name: 'string',
			experienceType: 'string',
			eventType: 'string',
		};
		const columnWidths = {
			name: 250,
		};
		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});

		const formData = programs.map(program => ({
			_id: program._id,
			name: program.name,
			experienceType: program.eventDefaults.details.experienceType,
			eventType: program.eventDefaults.details.eventType,
		}));

		switch (section) {
			case 0:
				let data = formData;
				if (searchTerm.length > 0) {
					const searchTerms = searchTerm.toLowerCase().split(' ');
					searchTerms.forEach((term) => {
						if (term != '') {
							data = data.filter((entry) => {
								let found = false;
								Object.keys(columns).forEach((key) => {
									if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
										found = true;
									}
								});
								return found;
							});
						}
					});
				}
				return <div className={`sectionBody w-100 posAbs anim left ${section == currentSection ? '' : 'closed'}`}>
					<div className='sectionBlock viewsTable'>
						<div style={{ textAlign: 'center' }}>
							<h1>Event from Program Creator</h1>
							<div className='mb-20  mt-10'>
								<p className='mb-10'>Choose an event to create an event from. You can create an event from any program you have access to.</p>
							</div>
						</div>
						<div className='sectionBlock viewsTable'>
							<div className='mb-10  mt-10 flex aic'>
								<InputField
									classes="m-0 viewSearch"
									placeholder="Search "
									clickIcon={true}
									required={true}
									value={searchTerm}
									onChange={(e) => {
										clearTimeout(this.searchTimeout);
										this.setState({ searchTerm: e.target.value },
											() => {
												this.searchTimeout = setTimeout(() => this.searchEntries(this.state.searchTerm), 1000);
											});
									}}
									prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
									inputIcon={searchTerm != '' &&
										<i
											onMouseDown={() => this.setState({ searchTerm: '', searching: false }, () => this.searchEntries(''))}
											className="las la-times-circle"
											style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
										/>}
								/>
							</div>
						</div>
						<div className="componentList p-0">
							<div className='mb-10 flex sectionContainer' style={{ height: '500px' }}>
								<ViewsTable
									title="Program"
									classes="h-100 mt-10 viewsTableScrollable"
									columns={normalizedColumns}
									toggledColumns={toggledColumns}
									columnWidths={columnWidths}
									data={data}
									mainColumnActive={false}
									checked={this.state.checkedEvent}
									checkRow={(programId) => {
										let checked = {}
										if (this.state.checkedEvent[programId]) {
											checked = {};
										} else {
											checked[programId] = true;
										}
										const program = checked[programId] ? this.props.programs.find(program => program._id === programId) : null;

										this.setState({
											checkedEvent: checked,
											chosenProgram: program,
											nextSectionEnabled: !!Object.keys(checked).length,
										});
									}}
									mainActions={{}}
									checkAllRows={{}}
									sortData={() => { }}
									singleCheck={true}
									disableCheck={false}
								/>
							</div>
						</div>
					</div>
				</div>

			case 1:
				return <div className={`sectionBody w-100 posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
					<div style={{ textAlign: 'center' }}>
						<h1>Event Information</h1>
						<div className='mb-20  mt-10'>
							<p className='mb-10'>
								Please enter the information below to set up your {experienceType == 'in-person' ? 'In-Person' : experienceType == 'virtual' ? 'Virtual' : 'Hybrid'} experience
							</p>

						</div>
					</div>

					<div className='flex flex-wrap jcc' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 80px)' }}>
						<div className={`sectionBlock mr-15 mb-15`} style={{ maxWidth: 500, paddingLeft: 1, paddingTop: 30 }}>
							<h3 className='blockHeader mb-20'>Basic Information</h3>
							<InputField
								label={'Event Name'}
								required={true}
								errorTrigger={requiredFields.name || this.state.isConflictsEventName}
								value={name}
								errorMessage={"Event name not supported"}
								onChange={(e) => {
									this.updateEventField('name', e.target.value);
								}}
								onBlur={(e) => {
									this.validateEventName(e.target.value);
								}}
							//subText={`URL: https://${this.props.organization.identifier}.simple.events/${name.replace(/[^A-Za-z0-9]/g, '')}`}
							/>
							<div className="flex-sb w-100">
								<div className="mr-10 w-100">
									<InputField
										label={'Start Date'}
										value={moment(startDate).format('yyyy-MM-DD')}
										required={true}
										min={moment().format('yyyy-MM-DD')}
										errorTrigger={requiredFields.startDate}
										type={'date'}
										inputIcon={<i className="lar la-calendar" />}
										onChange={(e) => {
											this.updateEventField('startDate', moment(e.target.value).format('MM/DD/YYYY'));
										}}
									/>
								</div>

								<div className="ml-10 w-100">
									<InputField
										label={'End Date'}
										value={moment(endDate).format('yyyy-MM-DD')}
										min={moment().format('yyyy-MM-DD')}
										required={true}
										errorTrigger={requiredFields.endDate}
										type={'date'}
										inputIcon={<i className="lar la-calendar" />}
										onChange={(e) => {
											this.updateEventField('endDate', moment(e.target.value).format('MM/DD/YYYY'));
										}}
									/>
								</div>
							</div>
							<ToggleField
								label="This will be a virtual only event"
								icons={false}
								checked={experienceType === 'virtual'}
								onChange={(e) => {
									const type = e.target.checked ? 'virtual' : 'hybrid';
									const updatedEvent = { ...event, experienceType: type };
									this.setState({ event: updatedEvent }, this.validateForm);
								}}
							/>

							{(experienceType == 'in-person' || experienceType == 'hybrid') && (
								<LocationLookup
									selectedPlace={this.state.selectedVenue}
									locations={this.props.locations}
									label="Location Finder"
									placeholder={<p className='grey'><i>Search for the venue where the event will take place</i></p>}
									noOptionsMessage="No results" onSelect={(location) => {
										if (location.timezone) {
											this.updateEventField('timezone', location.timezone);
										}
										this.setState({ selectedVenue: location, isNewVenue: !location.platform })
									}}
									classes="w-100"
								/>
							)}

							<SelectField
								label={'Timezone'}
								value={{
									value: timezone, label: <p>
										{timezone}
										<span className='grey'><i>{timezone ? ` (${moment().tz(timezone).zoneAbbr()})` : ''}</i></span>
									</p>
								}}
								placeholder="Search for nearest city"
								name="timezones"
								classes="w-100"
								options={cityTimezoneOptions}
								required={true}
								errorTrigger={requiredFields.timeZone}
								onInputChange={(text) => {
									this.setState({ cityLookup: text });
								}}
								noOptionsMessage={({ inputValue }) =>
									!inputValue ? 'Type city name to get options' : 'No cities match your search'}
								onChange={(timezone) => {
									this.updateEventField('timezone', timezone.value);
								}}
							/>

							<div className="w-100">
								<InputField
									label={'Expected Number of Attendees'}
									defaultValue={0}
									min={0}
									value={event.expectedNumberOfAttendees}
									required={true}
									errorTrigger={requiredFields.expectedNumberOfAttendees}
									type={'number'}
									onChange={(e) => {
										const value = Number(e.target.value);
										if (isNaN(value) || value < 0 || e.target.value.includes('-')) {
											return;
										}
										this.updateEventField('expectedNumberOfAttendees', String(value));
									}}
								/>
							</div>

							{salesforceEnabled && <div>
								<h3 className='blockHeader'>Salesforce</h3>
								<p className='small gray  mb-10'>Connect to Salesforce to sync attendee data and create new leads.</p>
								<ToggleField icons={false} label="Enable Salesforce Integration" checked={this.state.salesforceToggled} onChange={(checked) => {
									if (this.state.salesforceToggled) {
										let requiredFieldsAcquired = true;
										Object.keys(requiredFields).forEach((key) => {
											if (!event[key] || event[key] === '') {
												requiredFieldsAcquired = false;
											}
										});
										this.setState({ salesforceToggled: false, nextSectionEnabled: requiredFieldsAcquired, salesforceCampaign: '' });
									} else {
										this.setState({ salesforceToggled: true, nextSectionEnabled: false });
									}
								}} />
								{this.state.salesforceToggled && <div className="w-100">
									<InputField
										label={'Campaign Name'}
										value={this.state.salesforceCampaign}
										placeholder={'Name the Salesforce campaign for this event'}
										required={true}
										errorTrigger={requiredFields.salesforceCampaign}
										inputIcon={<i className="lab la-salesforce" />}
										onChange={(e) => {

											let requiredFieldsAcquired = true;
											Object.keys(requiredFields).forEach((key) => {
												if (!event[key] || event[key] === '') {
													requiredFieldsAcquired = false;
												}
											});
											if (!e.target.value || e.target.value === '') {
												requiredFieldsAcquired = false;
											}
											this.setState({ salesforceCampaign: e.target.value, nextSectionEnabled: requiredFieldsAcquired });
										}}
									/>

									<InputField
										label={'Registration Status'}
										value={this.state.salesforceRegistrationStatus}
										placeholder={'Registered'}
										onChange={(e) => {
											this.setState({ salesforceRegistrationStatus: e.target.value });
										}}
									/>

									<InputField
										label={'Checked In Status'}
										value={this.state.salesforceCheckedinStatus}
										placeholder={'Checked In'}
										onChange={(e) => {
											this.setState({ salesforceCheckedinStatus: e.target.value });
										}}
									/>

									<InputField
										label={'Did Not Attend Status'}
										value={this.state.salesforceNotAttendingStatus}
										placeholder={'Did Not Attend'}
										onChange={(e) => {
											this.setState({ salesforceNotAttendingStatus: e.target.value });
										}}
									/>
								</div>}
							</div>}


						</div>

					</div>
				</div>
			case 2:
				return <div className={`sectionBody w-100  posAbs anim ${section >= currentSection ? 'right' : 'left'} ${section == currentSection ? '' : 'closed'}`}>
					<div style={{ textAlign: 'center' }}>
						<h1>Additional Information</h1>
						<div className='mb-20  mt-10'>
							<p className='mb-10'>Fill in additional information for the event, optional unless required.</p>
						</div>
					</div>

					<div className='flex flex-wrap jcc pt-30' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 96px)' }} >

						<div className={`sectionBlock `} >

							<h3 className='blockHeader pb-20'>Additional Information</h3>
							{metadata.map(cf => {
								return (
									<InputField
										label={cf.fieldLabel}
										value={cf.fieldValue}
										required={chosenProgram ? chosenProgram.eventDefaults.details.requiredCustomFields.includes(cf.fieldId) : null}
										errorTrigger={customRequiredFields[cf.fieldId]}
										type={cf.type}
										onChange={(e) => {
											this.handleMetadataChange(cf.fieldId, e.target.value)
										}}
									/>
								)
							})}
							{this.state.submitError && (
							<div className="formFieldLabel error" style={{ textAlign: 'center', marginTop: '20px' }}>
								<p><strong>Error:</strong> {this.state.submitError}</p>
							</div>
						)}
						</div>
					</div>
				</div>
			default:
				break;
		}
	}
	nextSection = () => {
		const { currentSection, chosenProgram, event } = this.state;
		if (currentSection === 0 && chosenProgram) {
			const eventFromProgramDetails = {
				experienceType: chosenProgram.eventDefaults.details.experienceType,
				eventType: chosenProgram.eventDefaults.details.eventType,
				eventBranding: {
					accentColor: chosenProgram.eventDefaults.details.branding.accentColor,
					fontColor: chosenProgram.eventDefaults.details.branding.fontColor,
					backgroundColor: chosenProgram.eventDefaults.details.branding.backgroundColor,
					headerImage: chosenProgram.eventDefaults.details.branding.headerImage,
					logo: chosenProgram.eventDefaults.details.branding.logo,
					favicon: chosenProgram.eventDefaults.details.branding.favicon,
				},
				timezone: chosenProgram.eventDefaults.details.timezone,
				allowPublicRegistrations: chosenProgram.eventDefaults.details.allowPublicRegistrations,
			};
			let programMembers = chosenProgram.members || [];
			programMembers = programMembers.map((member) => {
				let formattedPermissions = {};
				Object.keys(member.permissions).forEach((key) => {
					if (defaultPermissions[key]) {
						formattedPermissions[key] = { label: defaultPermissions[key].label, slug: key, write: member.permissions[key].write, read: member.permissions[key].read };
					}
				}
				);
				member.permissions = formattedPermissions;
				return member;
			});
			let eventTeam = programMembers.members || [];
			const programLocation = this.props.locations.find(v => v.value == chosenProgram.eventDefaults.details.venue);
			this.setState({
				event: { ...this.state.event, ...eventFromProgramDetails },
				eventBranding: { ...this.state.eventBranding, ...eventFromProgramDetails.eventBranding },
				currentSection: currentSection + 1,
				selectedVenue: programLocation || {},
				nextSectionEnabled: false,
				eventTeam: programMembers
			});
		} else {
			let nextSectionEnabled = false;
			let excludedSections = [2];
			let nextSection = currentSection + 1;
			if (excludedSections.includes(currentSection + 1)) {
				nextSectionEnabled = true;
			}
			if (nextSection == 2) {
            	this.checkRequiredCustomFields(false); 
			}
			if (this.state.currentSection == 2) {
				this.checkRequiredCustomFields(true);
			} else {
				this.setState({
					currentSection: nextSection,
					nextSectionEnabled: nextSectionEnabled
				});
			}
		}
	}


	prevSection = () => {
		const { currentSection } = this.state;
		this.setState({
			currentSection: currentSection - 1,
			nextSectionEnabled: true
		});
	}


	updateEventField = (field, value) => {
		const { event, requiredFields } = this.state;
		event[field] = value;

		let requiredFieldsAcquired = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!event[key] || event[key] === '') {
				requiredFieldsAcquired = false;
			}
		});
		this.setState({ event, nextSectionEnabled: requiredFieldsAcquired, requiredFields });
	}

	render() {
		const { isOpen, toggle } = this.props;
		const { nextSectionEnabled, currentSection, sectionCount, submitting } = this.state;
		return (
			<Modal isOpen={isOpen} toggle={toggle} className="stepSize eventModal">
				<button onClick={toggle} style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}><i className='las la-times'></i></button>
				<div className="modalHeader">
					<div className='headerContainer' style={{ position: 'relative' }}>

						<p className='grey small mt-10' style={{ position: 'absolute', right: 0 }}>Step {currentSection + 1} of {sectionCount}</p>

						{/* <div className='sectionIndicatorBar'>
								{Array.from(Array(sectionCount).keys()).map((i) => {
									return <div className={`sectionIndicator ${i <= currentSection ? 'selected' : ''}`}></div>
								})}
							</div> */}


					</div>
				</div>
				<ModalBody className="modalBody">
					{this.renderSection(0)}
					{this.renderSection(1)}
					{this.renderSection(2)}
				</ModalBody>



				<div className="flex">
					{currentSection == 0 ? <button className="neu ml-a mr-15" onClick={toggle}>Cancel</button> : <button className="neu ml-a mr-15" onClick={this.prevSection}>Back</button>}
					{currentSection < sectionCount - 1 ? <button className={`neu ${nextSectionEnabled ? 'prim' : 'disabled'}`}
						onClick={this.nextSection}>Next</button> : <button className={`neu ${!submitting && this.state.createEnabled ? 'prim' : 'disabled'}`} onClick={this.createEvent}>{submitting ? "Creating..." : "Create Event"}</button>}

				</div>

			</Modal>
		);
	}
}

export default AddEventFromProgramModal;
